import React, { useState } from "react";
import SubmitBtn from "../submitButton";
import { useNavigate } from "react-router-dom";
import PasswordInput from "../passwordInput";
import { resetPassword } from "../../services/auth.service";

function SetNewPasswordForm({ setCurrentStep = () => {} }) {
  const [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });
  const [formData, setFormData] = useState({
    pwd1: "",
    pwd2: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    setErrors({ hasError: false, msg: "" });

    if (
      !formData?.pwd1 ||
      !formData?.pwd2 ||
      formData?.pwd1 !== formData?.pwd2
    ) {
      setErrors({
        hasError: true,
        msg: "Le mot de passe et la confirmation ne doivent pas être vides et doivent correspondre.",
      });
      setloading(false);
      return;
    }

    const code = localStorage.getItem("resetPwdCode");
    const userID = localStorage.getItem("userResetPwdRequestID");

    if (!code || !userID) {
      setErrors({
        hasError: true,
        msg: "Le code et l'ID utilisateur sont manquants. Veuillez revenir à l'étape 1 pour redemander la réinitialisation du mot de passe.",
      });
      setloading(false);
      return;
    }

    const res = await resetPassword(userID, code, formData.pwd1);
    // const res = { success: true };

    if (res.success) {
      setloading(false);
      setCurrentStep(4);
      return;
    } else {
      setErrors({
        hasError: true,
        msg: res.msg,
      });
      setloading(false);
    }
  };

  return (
    <form
      id="SetNewPasswordForm"
      className="form-group"
      onSubmit={handleSubmit}
      aria-busy={loading}
    >
      <div className="error-msg">{errors.hasError && <p>{errors.msg}</p>}</div>
      <div className="row">
        <label htmlFor="pwd1">Nouveau mot de passe</label>
        <PasswordInput
          type="password"
          name="pwd1"
          id="pwd1"
          className="form__input"
          value={formData.pwd1}
          onChange={handleChange}
        />
      </div>
      <div className="row">
        <label htmlFor="pwd2">Confirmer le mot de passe</label>
        <PasswordInput
          type="password"
          name="pwd2"
          id="pwd2"
          className="form__input"
          value={formData.pwd2}
          onChange={handleChange}
        />
      </div>
      <SubmitBtn value="Réinitialiser le mot de passe" disabled={loading} />
      <button
        className="btn-back"
        onClick={(e) => {
          setCurrentStep(2);
        }}
      >
        {`< Retour à l’étape précédente`}
      </button>
    </form>
  );
}

export default SetNewPasswordForm;
